import createReducer from "reducers/createReducer";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";
import { addFiltering } from "reducers/common/Filtering";
import { addColumnFilters } from "reducers/common/ColumnFilters";

const initialState = {
	design: undefined,
	items: [],
	isLoading: false,
	isLoadingQrDesign: true,
	qrDesignHasErrors: false,
	hasErrorLoading: false,
	errorStatus: null,
	isSubmittingQrCodeDesign: false,
	totalPages: 1,
	totalItems: 0,
};

const SUBMIT_QR_CODES_ACTIONS = {
	SUBMIT_QR_DESIGN_AJAX: "SUBMIT_QR_DESIGN_AJAX",
	SUBMIT_QR_DESIGN_SUCCESS: "SUBMIT_QR_DESIGN_SUCCESS",
	SUBMIT_QR_DESIGN_ERROR: "SUBMIT_QR_DESIGN_ERROR",
};

const GET_QR_CODE_DESIGN_ACTIONS = {
	FETCH_QR_DESIGN_AJAX: "FETCH_QR_DESIGN_AJAX",
	FETCH_QR_DESIGN_SUCCESS: "FETCH_QR_DESIGN_SUCCESS",
	FETCH_QR_DESIGN_ERROR: "FETCH_QR_DESIGN_ERROR",
};

const SUBMIT_QR_CODES_HANDLERS = {
	[SUBMIT_QR_CODES_ACTIONS.SUBMIT_QR_DESIGN_AJAX]: submitQrDesignTriggered,
	[SUBMIT_QR_CODES_ACTIONS.SUBMIT_QR_DESIGN_SUCCESS]: submitQrDesignSuccess,
	[SUBMIT_QR_CODES_ACTIONS.SUBMIT_QR_DESIGN_ERROR]: submitQrDesignError,
};
const GET_QR_CODE_DESIGN_HANDLERS = {
	[GET_QR_CODE_DESIGN_ACTIONS.FETCH_QR_DESIGN_AJAX]: getQrDesignTriggered,
	[GET_QR_CODE_DESIGN_ACTIONS.FETCH_QR_DESIGN_SUCCESS]: getQrDesignSuccess,
	[GET_QR_CODE_DESIGN_ACTIONS.FETCH_QR_DESIGN_ERROR]: getQrDesignError,
};

const stateIsLoading = (state, isLoading = true) => {
	return {
		...state,
		isSubmittingQrCodeDesign: isLoading,
	};
};
export function submitQrDesignTriggered(state) {
	return stateIsLoading(state);
}
export function submitQrDesignSuccess(state) {
	return stateIsLoading(state, false);
}
export function submitQrDesignError(state) {
	return stateIsLoading(state, false);
}

export function getQrDesignTriggered(state) {
	return {
		...state,
		design: undefined,
		isLoadingQrDesign: true,
		qrDesignHasErrors: false,
	};
}
export function getQrDesignError(state) {
	return {
		...state,
		isLoadingQrDesign: false,
		qrDesignHasErrors: true,
	};
}
export function getQrDesignSuccess(state, action) {
	let { data } = action.payload;

	return {
		...state,
		design: data,
		isLoadingQrDesign: false,
		qrDesignHasErrors: false,
	};
}

export const QR_CODES_ACTIONS = {
	FETCH_QR_DESIGNS_AJAX: "FETCH_QR_DESIGNS_AJAX",
	FETCH_QR_DESIGNS_SUCCESS: "FETCH_QR_DESIGNS_SUCCESS",
	FETCH_QRS_ERROR: "FETCH_QRS_ERROR",
	FETCH_QR_DESIGN_BY_ID_AJAX: "FETCH_QR_DESIGN_BY_ID_AJAX",
	FETCH_QR_DESIGN_BY_ID_SUCCESS: "FETCH_QR_DESIGN_BY_ID_SUCCESS",
	RESET_DESIGNS_LIST: "RESET_DESIGNS_LIST",
	...SUBMIT_QR_CODES_ACTIONS,
	...GET_QR_CODE_DESIGN_ACTIONS,
	DUPLICATE_QR_DESIGN_REQUEST: "DUPLICATE_QR_DESIGN_REQUEST",
	DUPLICATE_QR_DESIGN_SUCCESS: "DUPLICATE_QR_DESIGN_SUCCESS",
	DUPLICATE_QR_DESIGN_ERROR: "DUPLICATE_QR_DESIGN_ERROR",
	DELETE_QR_CODE_DESIGN_REQUEST: "DELETE_QR_CODE_DESIGN_REQUEST",
	DELETE_QR_CODE_DESIGN_SUCCESS: "DELETE_QR_CODE_DESIGN_SUCCESS",
	DELETE_QR_CODE_DESIGN_ERROR: "DELETE_QR_CODE_DESIGN_ERROR",
};

export const handlers = {
	[QR_CODES_ACTIONS.FETCH_QR_DESIGNS_AJAX]: getQrDesignsRequest,
	[QR_CODES_ACTIONS.FETCH_QR_DESIGNS_SUCCESS]: getQrDesignsSuccess,
	[QR_CODES_ACTIONS.FETCH_QRS_ERROR]: getQrsError,
	[QR_CODES_ACTIONS.FETCH_QR_DESIGN_BY_ID_AJAX]: getQrDesignByIdRequest,
	[QR_CODES_ACTIONS.FETCH_QR_DESIGN_BY_ID_SUCCESS]: getQrDesignByIdSuccess,
	[QR_CODES_ACTIONS.RESET_DESIGNS_LIST]: resetQrDesignsList,
	...SUBMIT_QR_CODES_HANDLERS,
	...GET_QR_CODE_DESIGN_HANDLERS,
	[QR_CODES_ACTIONS.DUPLICATE_QR_DESIGN_REQUEST]: duplicateQrDesignRequest,
	[QR_CODES_ACTIONS.DUPLICATE_QR_DESIGN_SUCCESS]: duplicateQrDesignSuccess,
	[QR_CODES_ACTIONS.DUPLICATE_QR_DESIGN_ERROR]: duplicateQrDesignError,
	[QR_CODES_ACTIONS.DELETE_QR_CODE_DESIGN_REQUEST]: deleteQrCodeDesignRequest,
	[QR_CODES_ACTIONS.DELETE_QR_CODE_DESIGN_SUCCESS]: deleteQrCodeDesignSuccess,
	[QR_CODES_ACTIONS.DELETE_QR_CODE_DESIGN_ERROR]: deleteQrCodeDesignError,
};

let reducerConfig = {
	typeRoot: "QR_CODES",
	actionTypes: QR_CODES_ACTIONS,
	actionCreators: {
		getQrDesign,
		getQrDesigns,
		getQrDesignById,
		clearQrDesigns,
		submitQrDesign,
		submitEditionQrDesign,
		deleteQrCodeDesign,
		duplicateQrDesign,
	},
	initialState,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, { sort: "dateLastUpdate:DESC" });
reducerConfig = addColumnFilters(reducerConfig, {
	dateLastUpdate: {
		name: "dateLastUpdate",
		type: "Date",
		displayName: "Last Modified",
	},
});

export function getQrDesignsRequest(state, action) {
	return {
		...state,
		items: [],
		isLoading: true,
		hasErrorLoading: false,
	};
}

export function getQrDesignsSuccess(state, action) {
	let { data } = action.payload;

	return {
		...state,
		...data,
		isLoading: false,
		hasErrorLoading: false,
		errorStatus: null,
	};
}

export function getQrsError(state, action) {
	const errorStatus = action.payload?.error?.response?.status || null;
	return {
		...state,
		isLoading: false,
		hasErrorLoading: true,
		errorStatus,
	};
}

export function deleteQrCodeDesignRequest(state, action) {
	return {
		...state,
		isLoading: true,
		hasErrorLoading: false,
	};
}

export function deleteQrCodeDesignSuccess(state, action) {
	return {
		...state,
		isLoading: false,
		hasErrorLoading: false,
	};
}

export function deleteQrCodeDesignError(state, action) {
	return {
		...state,
		isLoading: false,
		hasErrorLoading: true,
	};
}

export function getQrDesignByIdRequest(state, action) {
	return {
		...state,
		currentDesign: null,
		isLoading: true,
		hasErrorLoading: false,
		errorStatus: null,
	};
}

export function getQrDesignByIdSuccess(state, action) {
	let { data } = action.payload;

	return {
		...state,
		currentDesign: data,
		isLoading: false,
		hasErrorLoading: false,
		errorStatus: null,
	};
}

export function duplicateQrDesignRequest(state, action) {
	return {
		...state,
		isLoading: true,
		hasErrorLoading: false,
	};
}

export function duplicateQrDesignSuccess(state, action) {
	return {
		...state,
		isLoading: false,
		hasErrorLoading: false,
	};
}

export function duplicateQrDesignError(state, action) {
	return {
		...state,
		isLoading: false,
		hasErrorLoading: true,
	};
}

export function getQrDesign(libraryId, idQrDesign) {
	return (dispatch) => {
		if (!idQrDesign) {
			return dispatch({
				type: GET_QR_CODE_DESIGN_ACTIONS.FETCH_QR_DESIGN_SUCCESS,
				payload: { data: { body: {} } },
			});
		}
		return dispatch({
			type: GET_QR_CODE_DESIGN_ACTIONS.FETCH_QR_DESIGN_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway:"qrm",
				url: `ui/creativelibraries/${libraryId}/qrcodedesigns/${idQrDesign}`,
				success: GET_QR_CODE_DESIGN_ACTIONS.FETCH_QR_DESIGN_SUCCESS,
				error: GET_QR_CODE_DESIGN_ACTIONS.FETCH_QR_DESIGN_ERROR,
			},
		});
	};
}

export function getQrDesigns(libraryId) {
	return (dispatch, getState) => {
		let state = getState();
		let { filterInfo } = state.qrDesigns;
		return dispatch({
			type: QR_CODES_ACTIONS.FETCH_QR_DESIGNS_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				params: filterInfo,
				url: `qrcodedesigns/creativelibraries/${libraryId}`,
				success: QR_CODES_ACTIONS.FETCH_QR_DESIGNS_SUCCESS,
				error: QR_CODES_ACTIONS.FETCH_QRS_ERROR,
				gateway: "qrm",
			},
		});
	};
}

export function getQrDesignById(libraryId, idDesign) {
	return (dispatch) => {
		return dispatch({
			type: QR_CODES_ACTIONS.FETCH_QR_DESIGN_BY_ID_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `ui/creativelibraries/${libraryId}/qrcodedesigns/${idDesign}`,
				success: QR_CODES_ACTIONS.FETCH_QR_DESIGN_BY_ID_SUCCESS,
				error: QR_CODES_ACTIONS.FETCH_QRS_ERROR,
				gateway: "qrm",
			},
		});
	};
}

export function submitQrDesign(libraryId, qrCodeDesignConfiguration) {
	return (dispatch) => {
		return dispatch({
			type: QR_CODES_ACTIONS.SUBMIT_QR_DESIGN_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway:"qrm",
				url: `qrcodedesigns/creativelibraries/${libraryId}`,
				method: "post",
				data: qrCodeDesignConfiguration,
				success: QR_CODES_ACTIONS.SUBMIT_QR_DESIGN_SUCCESS,
				error: QR_CODES_ACTIONS.SUBMIT_QR_DESIGN_ERROR,
			},
		});
	};
}

export function submitEditionQrDesign(idQrDesign, qrCodeDesignConfiguration) {
	return (dispatch) => {
		return dispatch({
			type: QR_CODES_ACTIONS.SUBMIT_QR_DESIGN_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway: "qrm",
				url: `qrcodedesigns/${idQrDesign}`,
				method: "put",
				data: qrCodeDesignConfiguration,
				success: QR_CODES_ACTIONS.SUBMIT_QR_DESIGN_SUCCESS,
				error: QR_CODES_ACTIONS.SUBMIT_QR_DESIGN_ERROR,
			},
		});
	};
}

export function duplicateQrDesign(idDesign, name) {
	return (dispatch) => {
		return dispatch({
			type: QR_CODES_ACTIONS.DUPLICATE_QR_DESIGN_REQUEST,
			AJAX: {
				gateway: "qrm",
				url: `qrcodedesigns/${idDesign}/duplicates`,
				data: { name },
				method: "post",
				success: QR_CODES_ACTIONS.DUPLICATE_QR_DESIGN_SUCCESS,
				error: QR_CODES_ACTIONS.DUPLICATE_QR_DESIGN_ERROR,
			},
		});
	};
}

export function clearQrDesigns() {
	return (dispatch) => {
		dispatch({
			type: QR_CODES_ACTIONS.RESET_DESIGNS_LIST,
		});
		return Promise.resolve({ success: true });
	};
}

function resetQrDesignsList(state, action) {
	return {
		...initialState,
		filterInfo: state.filterInfo,
		columnFilters: state.columnFilters,
	};
}

export function deleteQrCodeDesign(idDesign) {
	return (dispatch) => {
		return dispatch({
			type: QR_CODES_ACTIONS.DELETE_QR_CODE_DESIGN_REQUEST,
			AJAX: {
				gateway: "qrm",
				url: `qrcodedesigns/${idDesign}`,
				method: "delete",
				success: QR_CODES_ACTIONS.DELETE_QR_CODE_DESIGN_SUCCESS,
				error: QR_CODES_ACTIONS.DELETE_QR_CODE_DESIGN_ERROR,
			},
		});
	};
}

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const QrDesigns = reducerConfig.actionCreators;
